<template>
  <div class="jzliu-bi-engine-bi-header">
    <div></div>
    <div class="jzliu-bi-engine-bi-header-content">
      <div class="dashboard-action-panel">
        <div class="action-panel-left">
          <i class="el-icon-s-data jzliu-bi-engine-bi-header-icon"></i>
          <input v-if="isEditMode" class="middle jzliu-bi-engine-bi-header-name-input"
            v-model="gridLayout.dashboardName" type="text" />
          <span v-else>{{ gridLayout.dashboardName }}</span>
        </div>
        <div class="action-panel-middle" v-show="false">
          <div class="device-switch-container">
            <div class="switch-content" @click="switchActive(true)">
              <i class="el-icon-monitor"></i>
            </div>
            <div class="switch-content" @click="switchActive(false)">
              <i class="el-icon-mobile"></i>
            </div>
            <div class="switch-bar" :style="switchPos"></div>
          </div>
        </div>
        <div class="action-panel-right">
          <div class="jzliu-bi-engine-bi-header-btn-wrapper">
            <el-button size="mini" @click="onCance">取消</el-button>
          </div>
          <div class="jzliu-bi-engine-bi-header-btn-wrapper" v-if="showShareBtn">
            <el-button size="mini" @click="onShare">分享</el-button>
          </div>
          <div class="jzliu-bi-engine-bi-header-btn-wrapper">
            <el-button size="mini" @click="onExportImg">导出</el-button>
          </div>
          <div class="jzliu-bi-engine-bi-header-btn-wrapper">
            <el-button size="mini" @click="btnPreview">预览</el-button>
          </div>
          <slot name="button"></slot>
          <div class="jzliu-bi-engine-bi-header-btn-wrapper" v-if="showExportJson">
            <el-button size="mini" @click="btnExportJson">导出JSON</el-button>
          </div>
          <div class="jzliu-bi-engine-bi-header-btn-wrapper">
            <el-button size="mini" type="primary" @click="btnSaveAndRelease('save')">保存</el-button>
          </div>
          <div class="jzliu-bi-engine-bi-header-btn-wrapper" v-if="showPublishBtn" style="margin-right: 12px;">
            <el-button size="mini" type="primary" @click="btnSaveAndRelease('publish')">保存并发布</el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 分享弹框 -->
    <el-dialog title="链接分享" :visible.sync="shareDialogVisible" width="480px" append-to-body modal-append-to-body
      :close-on-click-modal="false" :close-on-press-escape="true" custom-class="share-dialog">
      <div class="share-content">
        <div class="url-input-container">
          <el-input v-model="currentPageUrl" readonly placeholder="请复制链接分享给他人" class="url-input">
          </el-input>
          <el-button type="primary" @click="copyUrl" class="copy-btn" :loading="copyLoading">
            复制链接
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 移除 Vuex 依赖，使用事件通信
import { getParamsRowsAndColumns } from '../utils'
const saveDashboardConfig = () => { }

export default {
  name: 'actionPanel',
  props: {
    value: {
      type: Boolean,
      default: true,
    },
    showPublishBtn: {
      type: Boolean,
      default: true,
    }, 
    showShareBtn: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: '',
    },
    gridLayout: {
      type: Object,
      default: () => {},
    },
    previewFlag: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      active: this.value,
      shareDialogVisible: false,
      currentPageUrl: '',
      copyLoading: false,
    }
  },
  computed: {
    showExportJson() {
      const win = window.top || window
      return win.location.href.includes('jzliu=nb')
    },
    isEditMode() {
      return this.mode !== 'single'
    },
    // 使用 props 传递的状态
    getPreviewFlag() {
      return this.previewFlag
    },
    switchPos() {
      return this.active ? { left: 0 } : { left: '56px' }
    },
    previewBtnName() {
      return this.getPreviewFlag ? '编 辑' : '预 览'
    },
  },
  methods: {
    onShare() {
      this.$emit('on-share')
    },
    onCance() {
      this.$emit('on-cancel')
    },
    btnPreview() {
      this.$emit('on-preview')
    },
    onExportImg(){
      this.$emit('on-export-img')
    },
    btnExportJson() {
      try {
        // 准备导出的数据
        const exportData = {
          dashboardName: this.gridLayout.dashboardName,
          layout: this.gridLayout.layout,
          timestamp: new Date().toISOString(),
          version: '1.0.0',
        }
        
        // 转换为格式化的 JSON 字符串
        const jsonString = JSON.stringify(exportData, null, 2)
        
        // 创建 Blob 对象
        const blob = new Blob([jsonString], { type: 'application/json' })
        
        // 创建下载链接
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        
        // 设置文件名
        const fileName = `${this.gridLayout.dashboardName || 'dashboard'}_${new Date().toISOString().split('T')[0]}.json`
        link.download = fileName
        
        // 触发下载
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        
        // 清理 URL 对象
        URL.revokeObjectURL(url)
        
        this.$message.success('JSON 文件导出成功')
      } catch (error) {
        this.$message.error('导出 JSON 失败')
      }
    },
    async btnSave() {
      const { dashboardName, layout } = this.gridLayout
      const params = {
        wid: this.$route.query.wid,
        dashboardName,
        dashboardUnitInfos: layout.map((v) => {
          const { rowsCodes, columnCodes } = getParamsRowsAndColumns(v.fields)
          return {
            wid: v.wid,
            unitDefine: JSON.stringify(v),
            unitName: v.describe,
            unitQueryConfig: {
              faceTableCode: v.dataSetId,
              rowsCodes,
              columnCodes,
            },
          }
        }),
      }
      try {
        await saveDashboardConfig(params)
        this.$message.success('保存成功')
      } catch (e) {
        console.log('e:',e)
      }
    },
    btnSaveAndRelease(type) {
      console.log('this.gridLayout:',this.gridLayout)
      this.$emit('on-submit', type)
    },
    switchActive(type) {
      this.active = type
      this.$emit('input', this.active)
    },
    async copyUrl() {
      this.copyLoading = true
      try {
        // 使用现代的 Clipboard API
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(this.currentPageUrl)
        } else {
          // 降级方案：使用传统的 document.execCommand
          const textArea = document.createElement('textarea')
          textArea.value = this.currentPageUrl
          textArea.style.position = 'fixed'
          textArea.style.left = '-999999px'
          textArea.style.top = '-999999px'
          document.body.appendChild(textArea)
          textArea.focus()
          textArea.select()
          document.execCommand('copy')
          document.body.removeChild(textArea)
        }
        
        this.$message.success('链接已复制到剪贴板')
        // 复制成功后关闭弹框
        setTimeout(() => {
          this.shareDialogVisible = false
        }, 1000)
      } catch (error) {
        console.error('复制失败:', error)
        this.$message.error('复制失败，请手动复制')
      } finally {
        this.copyLoading = false
      }
    },
  },
}
</script>

<style scoped lang="less">
/deep/ .el-button--primary {
  border-radius: 3px;
}

.jzliu-bi-engine-bi-header {
  display: flex;
  background-color: var(--bi-jz-bg-color);
  user-select: none;
  position: relative;
  height: 50px;
  line-height: 50px;
  color: var(--bi-jz-font-color);
  width: 100%;
  border-bottom: 1px solid var(--bi-jz-border-color);

  .jzliu-bi-engine-bi-header-content {
    display: flex;
    flex: 1;

    .dashboard-action-panel {
      display: flex;
      flex-grow: 1;
      justify-content: space-between;
      align-items: center;

      .jzliu-bi-engine-bi-header-icon {
        vertical-align: middle;
        margin: 0 10px;
        font-size: 20px;
        color: var(--bi-jz-font-color);
      }

      .action-panel-middle {
        .device-switch-container {
          z-index: 1000;
          background: #141618;
          border-radius: 30px;
          display: flex;
          width: 120px;
          height: 28px;
          cursor: pointer;
          position: relative;

          .switch-content {
            width: 50%;
            display: block;
            text-align: center;
            line-height: 28px;
            color: var(--bi-jz-font-color);
            font-size: 16px;
          }

          .switch-bar {
            border:2px solid #141618;
            position: absolute;
            top: 0;
            width: 64px;
            height: 100%;
            border-radius: 99px;
            background-color: var(--bi-jz-bg-color);
            transition: all 0.3s;
            z-index: -1;
          }
        }
      }

      .action-panel-right {
        display: flex;
        align-items: center;
        flex-shrink: 0;

        .jzliu-bi-engine-bi-header-btn-wrapper {
          position: relative;
          margin-right: 12px;
        }

        .jzliu-bi-engine-bi-header-btn-wrapper ~ .jzliu-bi-engine-bi-header-btn-wrapper {
          margin-right: 12px;
        }
      }
    }
  }
}

// 分享弹框样式
:global(.share-dialog) {
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog__header {
    padding: 20px 20px 10px 20px;
    
    .el-dialog__title {
      font-weight: bold;
      color: #333;
      font-size: 16px;
    }
    
    .el-dialog__close {
      color: #999;
      font-size: 18px;
      
      &:hover {
        color: #666;
      }
    }
  }
  
  .el-dialog__body {
    padding: 10px 20px 20px 20px;
  }
}

.share-content {
  .url-input-container {
    display: flex;
    align-items: center;
    gap: 12px;
    background-color: #f5f5f5;
    border-radius: 8px;
    padding: 12px 16px;
    
    .url-input {
      flex: 1;
      
      :global(.el-input__inner) {
        background-color: #fff;
        border: 1px solid #e0e0e0;
        border-radius: 6px;
        font-size: 14px;
        color: #666;
        
        &:focus {
          border-color: var(bi-jz-primary-color);
        }
      }
    }
    
    .copy-btn {
      background-color: var(bi-jz-primary-color);
      border-color: var(bi-jz-primary-color);
      border-radius: 6px;
      padding: 10px 20px;
      font-size: 14px;
      font-weight: 500;
      white-space: nowrap;
      
      &:hover {
        background-color: #66b1ff;
        border-color: #66b1ff;
      }
      
      &:active {
        background-color: #3a8ee6;
        border-color: #3a8ee6;
      }
    }
  }
}
</style>
